import React, { useState } from 'react';
import api from "../../utils/axiosInstance";
import HeaderBlue from '../../components/HeaderBlue';
import FooterBlue from '../../components/FooterBlue';

const ForgotPassword = () => {
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState('');

    const handleForgot = async (e) => {
        e.preventDefault();
        try {
            const res = await api.post('/auth/forgot-password', { email });
            setMessage(res.data.message || "Check your email for reset instructions.");
        } catch (error) {
            setMessage(error.response?.data?.message || "Something went wrong.");
        }
    };

    return (
        <div className="bg-gray-100 min-h-screen flex flex-col font-oswald">
            <HeaderBlue />

            {/* Hero Section */}
            <section className="w-full py-60 relative"
                style={{
                    backgroundImage: "url('./assets/LOGIN.webp')",
                    backgroundSize: 'cover',
                    backgroundPosition: 'center'
                }}>
                <div className="absolute inset-0 bg-gradient-to-r from-black/80 to-white/10 z-0"></div>
                <div className="md:px-40 relative z-10"></div>
            </section>

            {/* Forgot Form Section */}
            <div className="flex items-center justify-center p-4 -mt-40 relative z-10 mb-10">
                <div className="w-full max-w-md p-8 rounded-lg shadow-xl border border-gray-300 bg-white/85 backdrop-blur-md">
                    <div className="text-center mb-8">
                        <h1 className="text-3xl font-bold text-primary mb-2">FORGOT PASSWORD</h1>
                        <p className="text-gray-600">Enter your email to reset your password</p>
                    </div>

                    <form onSubmit={handleForgot} className="space-y-6">
                        <div>
                            <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1">
                                Email
                            </label>
                            <input
                                type="email"
                                id="email"
                                required
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-secondary focus:border-transparent"
                                placeholder="Enter your email"
                            />
                        </div>

                        <div>
                            <button
                                type="submit"
                                className="w-full bg-secondary text-white font-bold py-2 px-4 rounded-md hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-secondary transition"
                            >
                                Send Reset Link
                            </button>
                        </div>
                    </form>

                    {message && <p className="text-center mt-4 text-sm text-gray-700">{message}</p>}
                </div>
            </div>

            <FooterBlue />
        </div>
    );
};

export default ForgotPassword;
